import { render, staticRenderFns } from "./EditTPA.vue?vue&type=template&id=4a8b135e&"
import script from "./EditTPA.vue?vue&type=script&lang=js&"
export * from "./EditTPA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports